<div class="reader-wrapper">
    <div class="reader-header">
        <a [routerLink]="['/scan-charger']">
            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.292893 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538408 7.04738 0.538408 6.65685 0.928933L0.292893 7.29289ZM14 7L1 7L1 9L14 9L14 7Z"
                    fill="white" />
            </svg>
        </a>
        <span>Prepaid Charger</span>
    </div>
    <div class="form-wrapper">
        <p class="top-strip">
            <span>{{ charger_type }}</span>
            <span>Wallet AMT {{ (currentBalance | currency:'INR') }}</span>
        </p>
        <p class="info-text">Please select your option to charger your vehicle <br/> (Unit bases / Amount bases)</p>
        <p class="rate-text">{{ consumption_amt_per_unit }} Rs/unit</p>
        <label for="phone" class="phone-label">Amount ₹</label>

        <div class="input-group">
            <input type="number" id="phone" maxlength="10" pattern="[0-9]*" placeholder="Enter Amount ₹"
                class="phone-input" [(ngModel)]="amount" (input)="onAmountChange()" />
        </div>

        <label for="Unit" class="phone-label">Unit (Kw/h)</label>

        <div class="input-group">
            <input type="number" id="Unit" maxlength="10" pattern="[0-9]*" placeholder="Enter Unit (Kw/h)"
                class="phone-input"[(ngModel)]="unit"
                (input)="onUnitChange()" />
        </div>

        <button *ngIf="payneed; else loginBlock" type="button" class="login-button" (click)="pay()">
            Pay Now {{ payAmount > 0 ? '(' + (payAmount | currency:'INR') + ')' : '' }}
        </button>
        <ng-template #loginBlock>
            <a [routerLink]="['/charger-status']" class="login-button go-to-charging">Go To charging</a>
        </ng-template>
    </div>
    <footer class="web-footer">
        <a href="https://ezy-charge.com/about-us.php" target="_blank" style="color: #00796a;">About Us</a>
        <a href="https://ezy-charge.com/contact.php" target="_blank" style="color: #00796a;">Contact Us</a>
        <a href="https://ezy-charge.com/privacy-policy.php" target="_blank" style="color: #00796a;">Privacy & Policy</a>
        <a href="https://ezy-charge.com/refund-cancellation-policy.php" target="_blank" style="color: #00796a;">Refund & Cancellation Policy</a>
    </footer>
</div>